/**
 *
 * Copyright (c) 2019-present, wobe-systems GmbH
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * to be found in the LICENSE file in the root directory of this source tree.
 */

import {
  httpClient, BASE_URL, PORTS, SERVICES,
} from '@/middlewares/httpClient';
import { FLOW_MANAGER } from '../flow/apis';

const InstallPackage = (userId:string, id:string) => httpClient.post(`${FLOW_MANAGER}/users/${userId}/packages/${id}`);
const DeletePackage = (userid: string, id: string) => httpClient
  .delete(`${FLOW_MANAGER}/users/${userid}/packages/${id}`);
const PostBrick = (userid: string, files: any) => httpClient.post(`${FLOW_MANAGER}/users/${userid}/packages`, files);
const GetBricks = (id : string) => httpClient.get(`${FLOW_MANAGER}/users/${id}/bricks`);
const GetPackages = (id : string) => httpClient.get(`${FLOW_MANAGER}/users/${id}/packages`);

export {
  GetBricks,
  PostBrick,
  DeletePackage,
  GetPackages,
  InstallPackage,
};
